import { NgFor } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';
import {
	ChartLegendComponent,
	ChartLegendOption
} from '@brand-lolly/app/social-media-influencer/modules/discovery-v2/components/discovery-profile/components/chart-legend.component';
import { TypographyComponent } from 'components';

export interface SourceBarItem {
	label: string;
	color: string;
	percentage: number;
}

@Component({
	standalone: true,
	selector: 'app-ai-summary-source-bar',
	imports: [NgFor, TypographyComponent, ChartLegendComponent],
	templateUrl: './ai-summary-source-bar.component.html',
	styleUrls: ['./ai-summary-source-bar.component.scss']
})
export class AiSummarySourceBarComponent implements OnChanges {
	@Input() title: string = '';
	@Input() items: SourceBarItem[] = [];

	legendOptions: ChartLegendOption[] = [];

	ngOnChanges(): void {
		this.legendOptions = this.items.map(item => ({
			color: item.color,
			title: item.label,
			value: Math.round(item.percentage) + '%'
		}));
	}
}
